export default "__VITE_ASSET__tQDq7ymE__"